import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import * as React from 'react'

import { cn } from '../utils'
import { Icon } from './icon'

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn(
        'grid gap-2',
        { 'cursor-not-allowed opacity-50': props.disabled },
        className,
      )}
      {...props}
      ref={ref}
    />
  )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'border-input-secondary-foreground data-[state=checked]:border-input-foreground data-[state=checked]:bg-input-foreground ring-offset-background focus:outline-hidden relative aspect-square h-5 shrink rounded-full border-[1.5px] text-white',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex shrink-0 items-center justify-center">
        <Icon
          name="circle"
          weight="fill"
          className="text-input-background absolute left-1/2 top-1/2 h-2 w-2 -translate-x-1/2 -translate-y-1/2 fill-current"
        />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
